"use client"

import { setLanguage } from "@/tolgee/language"
import { useTolgee } from "@tolgee/react"
import { useState } from "react"

type LanguageOption = {
  code: string
  label: string
}

const LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: "en", label: "English" },
  { code: "zh", label: "中文" },
]

export const BarebonesLanguageSwitcher = () => {
  const tolgee = useTolgee(["language"])
  const currentLanguage = tolgee.getLanguage() ?? "en"
  const [open, setOpen] = useState(false)
  const [pending, setPending] = useState(false)

  const current =
    LANGUAGE_OPTIONS.find((o) => o.code === currentLanguage) ??
    LANGUAGE_OPTIONS[0]

  const handleSelect = async (option: LanguageOption) => {
    if (option.code === currentLanguage || pending) return
    setPending(true)
    setOpen(false)
    await tolgee.changeLanguage(option.code)
    await setLanguage(option.code)
    setPending(false)
  }

  return (
    <div
      className="relative"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        disabled={pending}
        aria-label="Select language"
        aria-expanded={open}
        aria-haspopup="menu"
        className="bb-nav-trigger inline-flex h-8 items-center px-1 text-[11px] uppercase tracking-[0.16em] text-[#2b2118] transition-opacity hover:opacity-70 disabled:opacity-50"
      >
        {current.code}
      </button>

      <div
        className={`bb-dropdown bb-dropdown--end absolute right-0 top-full z-50 pt-3 ${
          open ? "bb-dropdown--open" : ""
        }`}
        aria-hidden={!open}
      >
        <div role="menu" className="bb-dropdown-panel min-w-[160px]">
          <p className="bb-dropdown-heading">Language</p>
          {LANGUAGE_OPTIONS.map((option) => {
            const active = option.code === currentLanguage
            return (
              <button
                key={option.code}
                type="button"
                role="menuitem"
                disabled={pending}
                tabIndex={open ? 0 : -1}
                onClick={() => void handleSelect(option)}
                className={`bb-dropdown-item w-full text-left ${
                  active ? "bb-dropdown-item--active" : ""
                }`}
              >
                {option.label}
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}
